/**
 * @generated SignedSource<<d0bce3560a6d647bb0e2064f64f1c1c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassExitSlipsFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  dueOnFrom?: any | null | undefined;
  dueOnTo?: any | null | undefined;
  includeCanceled?: boolean | null | undefined;
  userIds?: ReadonlyArray<string> | null | undefined;
};
export type LearnosityExitSlipSessionsFilterInput = {
  classExitSlipIds?: ReadonlyArray<string> | null | undefined;
  classIds?: ReadonlyArray<string> | null | undefined;
  curriculumLessonIds?: ReadonlyArray<string> | null | undefined;
  sessionCompletedOn?: any | null | undefined;
  sessionStartedOn?: any | null | undefined;
  userIds?: ReadonlyArray<string> | null | undefined;
};
export type ExitSlipClassExitSlipsQuery$variables = {
  filter?: ClassExitSlipsFilterInput | null | undefined;
  learnosityExitSlipSessionsFilter?: LearnosityExitSlipSessionsFilterInput | null | undefined;
};
export type ExitSlipClassExitSlipsQuery$data = {
  readonly classExitSlips: ReadonlyArray<{
    readonly canceledOn: any | null | undefined;
    readonly class: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly userClasses: ReadonlyArray<{
        readonly createdOn: any;
        readonly user: {
          readonly fullName: string | null | undefined;
          readonly id: string;
          readonly lastName: string | null | undefined;
          readonly publicUserId: string | null | undefined;
          readonly roles: ReadonlyArray<{
            readonly id: string;
            readonly name: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly curriculumLesson: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly number: string | null | undefined;
      readonly skills: ReadonlyArray<{
        readonly code: string | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly targetGroup: {
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly learnosityExitSlipSessions: ReadonlyArray<{
      readonly activityId: string | null | undefined;
      readonly id: string;
      readonly isComplete: boolean;
      readonly items: ReadonlyArray<{
        readonly attempted: boolean;
        readonly id: string;
        readonly itemReference: string | null | undefined;
        readonly maxScore: number;
        readonly questionNumber: number | null | undefined;
        readonly score: number | null | undefined;
      } | null | undefined> | null | undefined;
      readonly maxScore: number;
      readonly publicUserId: string | null | undefined;
      readonly score: number;
      readonly sessionId: any;
      readonly user: {
        readonly firstName: string | null | undefined;
        readonly fullName: string | null | undefined;
        readonly lastName: string | null | undefined;
        readonly publicUserId: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  }>;
};
export type ExitSlipClassExitSlipsQuery = {
  response: ExitSlipClassExitSlipsQuery$data;
  variables: ExitSlipClassExitSlipsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "learnosityExitSlipSessionsFilter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canceledOn",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "skills",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    (v2/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "learnosityExitSlipSessionsFilter",
    "variableName": "learnosityExitSlipSessionsFilter"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activityId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplete",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxScore",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUserId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "LearnosityExitSlipSessionResponseNode",
  "kind": "LinkedField",
  "name": "items",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "itemReference",
      "storageKey": null
    },
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attempted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "questionNumber",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOn",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNode",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleNode",
      "kind": "LinkedField",
      "name": "roles",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExitSlipClassExitSlipsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassExitSlipNode",
        "kind": "LinkedField",
        "name": "classExitSlips",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CurriculumLessonNode",
            "kind": "LinkedField",
            "name": "curriculumLesson",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetGroupNode",
                "kind": "LinkedField",
                "name": "targetGroup",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "LearnosityExitSlipSessionNode",
            "kind": "LinkedField",
            "name": "learnosityExitSlipSessions",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v2/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "class",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserClassNode",
                "kind": "LinkedField",
                "name": "userClasses",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExitSlipClassExitSlipsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassExitSlipNode",
        "kind": "LinkedField",
        "name": "classExitSlips",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CurriculumLessonNode",
            "kind": "LinkedField",
            "name": "curriculumLesson",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetGroupNode",
                "kind": "LinkedField",
                "name": "targetGroup",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "LearnosityExitSlipSessionNode",
            "kind": "LinkedField",
            "name": "learnosityExitSlipSessions",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v2/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v11/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "class",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserClassNode",
                "kind": "LinkedField",
                "name": "userClasses",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "99c7e3de9914646b949652226b0568b0",
    "id": null,
    "metadata": {},
    "name": "ExitSlipClassExitSlipsQuery",
    "operationKind": "query",
    "text": "query ExitSlipClassExitSlipsQuery(\n  $filter: ClassExitSlipsFilterInput\n  $learnosityExitSlipSessionsFilter: LearnosityExitSlipSessionsFilterInput\n) {\n  classExitSlips(filter: $filter) {\n    id\n    canceledOn\n    curriculumLesson {\n      id\n      number\n      name\n      skills {\n        code\n        id\n        name\n      }\n      targetGroup {\n        name\n        id\n      }\n    }\n    learnosityExitSlipSessions(learnosityExitSlipSessionsFilter: $learnosityExitSlipSessionsFilter) {\n      activityId\n      id\n      isComplete\n      maxScore\n      publicUserId\n      score\n      sessionId\n      items {\n        id\n        score\n        itemReference\n        maxScore\n        attempted\n        questionNumber\n      }\n      user {\n        firstName\n        lastName\n        fullName\n        publicUserId\n        id\n      }\n    }\n    class {\n      id\n      name\n      userClasses {\n        createdOn\n        user {\n          id\n          lastName\n          fullName\n          publicUserId\n          roles {\n            id\n            name\n          }\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da8e2050611a732d79f351f4dc88f1b4";

export default node;
